import { render, staticRenderFns } from "./ReceivableSection.vue?vue&type=template&id=efa552aa&scoped=true"
import script from "./ReceivableSection.vue?vue&type=script&lang=js"
export * from "./ReceivableSection.vue?vue&type=script&lang=js"
import style0 from "./ReceivableSection.vue?vue&type=style&index=0&id=efa552aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa552aa",
  null
  
)

export default component.exports